import { FunctionalComponent, h } from 'preact';

export const CssOverride: FunctionalComponent<{ cssOverrides: string | undefined }> = ({ cssOverrides }) => {
  if (!cssOverrides) return null;
  return <style>{cssOverrides}</style>;
};
